import { QueryClient } from '@tanstack/react-query';

/**
 * Query defaults chosen for an operations console: data is read far more often
 * than it changes, but a stale queue depth is worse than a redundant request,
 * so nothing is cached for long.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        // Retries are decided per-error by the API client, which knows which
        // codes are transient. A blanket retry would hammer a 500.
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
